// extracted by mini-css-extract-plugin
export default {"wrapper":"Editable_wrapper__QYuW2","wrapper__input":"Editable_wrapper__input__zbFSa"};